(() => {
  if (window.OvilixaDeliveryLocalization) return;

  const COUNTRY_KEY = 'ovilixaDeliveryCountry';
  const PROVINCE_KEY = 'ovilixaDeliveryProvince';
  const MIGRATION_KEY = 'ovilixaDeliveryMarketMigration';
  const MIGRATION_VERSION = '1';
  const REOPEN_CART_KEY = 'ovilixaReopenCartAfterMarketChange';

  const read = (key) => {
    try { return sessionStorage.getItem(key) || ''; } catch (_) { return ''; }
  };
  const write = (key, value) => {
    try {
      if (value) sessionStorage.setItem(key, value);
      else sessionStorage.removeItem(key);
    } catch (_) { /* Market switching still works when storage is unavailable. */ }
  };
  const marketCountry = (fallback = 'US') => String(window.Shopify?.country || fallback || 'US').toUpperCase();
  const localizationForm = () => [...document.forms].find((form) =>
    form.method.toLowerCase() === 'post' && form.querySelector('input[name="country_code"]'));

  const submitCountry = (countryCode, { reopenCart = false } = {}) => {
    const code = String(countryCode || '').toUpperCase();
    if (!code || window.__ovilixaLocalizationSubmitting) return false;
    write(COUNTRY_KEY, code);
    write(PROVINCE_KEY, '');
    if (code === marketCountry()) return false;

    const form = localizationForm();
    if (!form) return false;
    const input = form.querySelector('input[name="country_code"]');
    const returnTo = form.querySelector('input[name="return_to"]');
    if (!input) return false;

    window.__ovilixaLocalizationSubmitting = true;
    document.documentElement.classList.add('ov-market-updating');
    input.value = code;
    if (returnTo) returnTo.value = `${location.pathname}${location.search}${location.hash}`;
    write(REOPEN_CART_KEY, reopenCart ? '1' : '');
    form.submit();
    return true;
  };

  const reconcileLegacySelection = (fallback, availableCodes = []) => {
    const current = marketCountry(fallback);
    const saved = read(COUNTRY_KEY).toUpperCase();
    const codes = availableCodes.map((code) => String(code).toUpperCase());

    if (read(MIGRATION_KEY) !== MIGRATION_VERSION) {
      write(MIGRATION_KEY, MIGRATION_VERSION);
      if (saved && saved !== current && codes.includes(saved)) {
        return submitCountry(saved);
      }
    }

    if (saved !== current) {
      write(COUNTRY_KEY, current);
      write(PROVINCE_KEY, '');
    }
    return false;
  };

  const reopenCartIfRequested = () => {
    if (read(REOPEN_CART_KEY) !== '1') return;
    write(REOPEN_CART_KEY, '');
    const open = () => {
      const drawer = document.querySelector('cart-drawer');
      const trigger = document.querySelector('#cart-icon-bubble');
      if (drawer?.open) drawer.open(trigger);
    };
    if (customElements.get('cart-drawer')) setTimeout(open, 80);
    else customElements.whenDefined('cart-drawer').then(() => setTimeout(open, 80));
  };

  window.OvilixaDeliveryLocalization = {
    countryKey: COUNTRY_KEY,
    provinceKey: PROVINCE_KEY,
    marketCountry,
    reconcileLegacySelection,
    submitCountry,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reopenCartIfRequested, { once: true });
  else reopenCartIfRequested();
})();
